import styled from "styled-components";

export const CardImageWrapper = styled.img`
  border-radius: 4%;
`;
